import React from 'react';
import { BuildingStorefrontIcon } from '@heroicons/react/24/outline';
import { cn } from '../../../components/ui/_cn';
import TWSelect from '../../../components/ui/tw-select';
import TWInput from '../../../components/ui/tw-input';
import { INVENTORY_STATUS_FILTERS } from '../inventory-utils';

// Echo the status-badge colour language on the relevant filter chips.
const chipDotTone = {
  1: 'bg-emerald-500',
  2: 'bg-slate-400',
  3: 'bg-amber-500',
  4: 'bg-rose-500',
};

const InventoryFilters = ({
  storeList,
  storesLoading,
  storeId,
  onStoreChange,
  categoryList,
  categoryId,
  onCategoryChange,
  statusFilter,
  onStatusFilterChange,
  search,
  onSearchChange,
}) => (
  <div className="space-y-4">
    <div className="grid gap-4 sm:grid-cols-3">
      <TWSelect
        label="Store"
        labelIcon={BuildingStorefrontIcon}
        loading={storesLoading}
        placeholder="Select store"
        value={storeId || undefined}
        onChange={onStoreChange}
        options={storeList.map((s) => ({ label: s.name, value: s.id }))}
        allowClear={false}
      />
      <TWSelect
        label="Category"
        placeholder="All Categories"
        value={categoryId || 'all'}
        onChange={(val) => onCategoryChange(val === 'all' ? null : val)}
        options={[
          { label: 'All Categories', value: 'all' },
          ...categoryList.map((c) => ({ label: c.categoryName, value: c.categoryId })),
        ]}
      />
      <TWInput
        label="Search"
        placeholder="Product or option name"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
      />
    </div>
    <div className="flex flex-wrap gap-2">
      {INVENTORY_STATUS_FILTERS.map((chip) => {
        const active = statusFilter === chip.value;
        return (
          <button
            key={chip.value}
            type="button"
            onClick={() => onStatusFilterChange(chip.value)}
            className={cn(
              'inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-sm font-medium transition',
              active
                ? 'bg-slate-900 text-white shadow-sm dark:bg-sky-500 dark:text-slate-900'
                : 'bg-slate-100 text-slate-600 hover:bg-slate-200 dark:bg-slate-700 dark:text-slate-300 dark:hover:bg-slate-600',
            )}
          >
            {chipDotTone[chip.value] ? (
              <span
                className={cn(
                  'h-1.5 w-1.5 rounded-full',
                  active ? 'bg-current opacity-80' : chipDotTone[chip.value],
                )}
                aria-hidden
              />
            ) : null}
            {chip.label}
          </button>
        );
      })}
    </div>
  </div>
);

export default InventoryFilters;
